module.exports = __webpack_public_path__ + "static/media/dtree.3eb2974d.jpg";